module.exports = __webpack_public_path__ + "img/68.48e73a54.jpg";